import { Cookies } from 'react-cookie';

export const removeJWTCookie = (): void => {
  const cookies = new Cookies();
  cookies.remove('jwt');
};
